import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BodyClassManager = () => {
    const location = useLocation();

    useEffect(() => {
        document.body.className = '';

        if (location.pathname === '/calculators') {
            document.body.classList.add('overflow-hidden');
        }

        return() => {
            document.body.className = '';
        }
    }, [location.pathname]);

    return null;
}

export default BodyClassManager;